module.exports = __webpack_public_path__ + "static/media/target.23615cac.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/target.svg
 ** module id = 783
 ** module chunks = 0
 **/